export default __webpack_public_path__ + "media/images/delete2_disabled_old-7ee07cf821f068a3f308a3c2257d197c.png";